import axios from 'axios';

const accessToken = localStorage.getItem('access_token');

const headers = {
  "Content-Type": "application/json",
  'Access-Control-Allow-Origin': '*',
  'X-Requested-With': 'XMLHttpRequest',
  'Accept': "application/json",
  'Authorization': `Bearer ${accessToken}`,
  'userId': localStorage.getItem("user_id") || "error",
}

let api_access = axios.create({
  baseURL: '/cra/api',
  headers: headers,
  withCredentials: false
});

if (!window.location.href.includes('localhost')) {
  api_access = axios.create({
    baseURL: '/cra/api',
    headers: headers,
    withCredentials: false
  });
} else {
  api_access = axios.create({
    baseURL: 'http://localhost:8080/cra/api',
    // baseURL: 'https://cra-app.dev.aws.jpmchase.net/cra/api',
    headers: headers,
    withCredentials: false
  });
}
api_access.interceptors.request.use(async (config) => {
  const accessToken = localStorage.getItem('access_token');
  config.headers.Authorization = `Bearer ${accessToken}`;
  config.headers.userId = localStorage.getItem("user_id");
  return config;
})

function hasMessageProperty(obj: unknown): obj is { message: string } {
  return typeof obj === "object" && obj !== null && typeof (obj as any).message === "string";
}

api_access.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const data = error?.response?.data;

    const is429Wrapped500 =
      status === 500 && Array.isArray(data) &&
      hasMessageProperty(data[0]) &&
      data[0].message.includes("429");
    const isUnauthorized =
      status === 401 && typeof data?.error === "string" && data.error.includes("Unauthorized");

    if (is429Wrapped500 || isUnauthorized) {
      const retryAfterHeader =
        error?.response?.headers?.["retry-after"] ??
        error?.response?.headers?.["Retry-After"];
      const retryAfterMs = parseRetryAfterMs(
        typeof retryAfterHeader === "string" ? retryAfterHeader : undefined
      );

      // Exponential backoff with bounds (1s..30s)
      const delay = Math.min(Math.max(retryAfterMs * 2, 1000), 30000);
      console.warn(`Too many requests. Retrying in ${Math.round(delay / 1000)}s...`);

      await sleep(delay);

      // Re-issue request (ensure config exists and avoid infinite loops if needed)
      if (error.config) {
        return api_access.request(error.config);
      }
    }

    return Promise.reject(error);
  }
);

// Helper to parse Retry-After as seconds or HTTP-date -> ms
function parseRetryAfterMs(headerValue?: string): number {
  if (!headerValue) return 1000; // default 1s
  const sec = Number(headerValue);
  if (Number.isFinite(sec) && sec >= 0) {
    return sec * 1000;
  }
  // If it's not a number, it may be an HTTP-date
  const dateMs = Date.parse(headerValue);
  if (!Number.isNaN(dateMs)) {
    const diff = dateMs - Date.now();
    return diff > 0 ? diff : 1000; // future date -> ms until then; else default
  }
  return 1000; // fallback
}

// Promise-based sleep that only accepts a finite, bounded number
function sleep(ms: number): Promise<void> {
  const safe = Math.min(Math.max(Number(ms) || 0, 1000), 30000); // 1s..30s
  return new Promise((resolve) => {
    // IMPORTANT: pass a function, not a string
    setTimeout(() => resolve(), safe);
  });
}

export default api_access;
